<template>
  <v-row class="ma-0 pa-0">
    <v-col>
      <apexchart ref="ref" :type="type" :width="width" :height="height" :options="options" :series="series">
      </apexchart>
    </v-col>
    <v-col v-if="rangeCtrl" cols="1" class="d-flex align-start flex-column">
      <v-text-field type="number" v-model="max" :min="Number(min)" class="mt-0 pt-0 mb-auto" />
      <v-text-field type="number" v-model="min" :max="Number(max)" class="mt-10 pt-0 mb-0 pb-0" />
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'Chart',
    props: {
      type: {
        type: String,
      },
      width: {
        type: String,
        default: '100%',
      },
      height: {
        type: String,
      },
      rangeCtrl: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      options: {
        xaxis: {
          type: 'datetime',
          labels: {
            style: {
              fontSize: '1rem',
            },
            datetimeFormatter: {
              year: 'yyyy',
              month: 'yyyy/MM',
              day: 'MM/dd',
              hour: 'HH:mm',
            },
          },
          tooltip: {
            style: {
              fontSize: '1rem',
            },
          },
        },
        yaxis: [
          {
            labels: {
              style: {
                fontSize: '1rem',
              },
            },
            title: {
              text: '',
              align: 'center',
              style: {
                fontSize: '1rem',
              },
            },
          },
        ],
        tooltip: {
          style: {
            fontSize: '1rem',
          },
          x: {
            format: 'yyyy/MM/dd HH:mm:ss',
          },
        },
        legend: {
          fontSize: '15px',
          showForSingleSeries: true,
        },
        stroke: {
          curve: 'straight',
        },
        chart: {
          animations: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
          fontFamily: '"Meiryo", "メイリオ", "Yu Gothic", "游ゴシック体", "Hiragino Kaku Gothic ProN", sans-serif',
        },
        markers: {
          showNullDataPoints: false,
        },
        annotations: {},
        dataLabels: {
          enabled: false,
        },
      },
      series: [],
      max: undefined,
      min: undefined,
    }),
    watch: {
      max: async function (newValue) {
        this.newOptions.yaxis[0].max = Number(newValue);
        await this.$refs.ref.updateOptions(this.newOptions);
      },
      min: async function (newValue) {
        this.newOptions.yaxis[0].min = Number(newValue);
        await this.$refs.ref.updateOptions(this.newOptions);
      },
    },
    methods: {
      getOptions() {
        return this.options;
      },
      async updateOptions(newOptions) {
        this.newOptions = newOptions;
        this.max = newOptions.yaxis[0].max;
        this.min = newOptions.yaxis[0].min;
        await this.$refs.ref.updateOptions(this.newOptions);
      },
      async updateSeries(newSeries) {
        // 最大値、最小値が設定されていない場合は実データから設定
        if (isNaN(this.max) || isNaN(this.min)) {
          let max, min, values;
          if (this.type === 'line') {
            // 全ての値を展開して、最大・最小値を決定
            values = newSeries.flatMap((dataList) => {
              return dataList.data.map((data) => {
                return data.y;
              });
            });
            max = Math.max(...values);
            min = Math.min(...values);
            if (min === 0 && max === 0) {
              max = 1;
            }
          }

          if (isNaN(this.max)) {
            if (max !== Infinity && max !== -Infinity) {
              this.max = max;
            }
          }
          if (isNaN(this.min)) {
            if (min !== Infinity && min !== -Infinity) {
              this.min = min;
            }
          }
        }

        await this.$refs.ref.updateSeries(newSeries);
      },
      hideSeries(seriesName) {
        this.$refs.ref.hideSeries(seriesName);
      },
      async dataURI() {
        return await this.$refs.ref.dataURI();
      },
    },
  };
</script>
